import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { View } from 'react-native';
import PaperForm from '../forms/PaperForm';
import WebObservationForm from '../forms/WebObservationForm';
import WasteTrackingForm from '../forms/WasteTrackingForm';
import ReportRequestForm from '../forms/ReportRequestForm';
import ProjectStatusForm from '../forms/ProjectStatusForm';
import { useAuth } from '../../../../providers/AuthProvider';
import { useClient } from '../../../../providers/ClientProvider';
import { findProjectParent, getAllItems, findImmediateParent, getPackageStatus } from '../service/dataOperations';
import { useNav } from '../../../../providers/NavProvider';
import RightPanel from './RightPanel';
import ReactDataTable from './ReactDataTable';

interface Props {
  data: Array<any>;
  columns: Array<any>;
  siteId: string;
  logTitle: string;
  updateData: (item: Array<any>) => void;
  isConsolidatedTable: boolean;
  Permissions?: string;
  QueryStringID?: string;
  chartVisibility?: any;
  funcSetShowFilter?: any;
  setRefreshData?: (e: boolean) => void;
  selectedYear?: string;
}
const PaperTableDynamic: React.FC<Props> = (props) => {

  //let data = props.data; // Use directly to ensure updates
  const [data, setData] = useState(props.data);
  const sortedData = useMemo(() => {
    return data ? [...data].sort((a, b) => b.ID - a.ID) : [];
  }, [data]);

  const columns = useMemo(() => {
    const base = props.columns
      .filter(column => column.columnName !== "Title" && column.columnName !== "SPID" && column.columnName !== "Semester")
      .sort((a, b) => a.order - b.order);

    const Editable = {
      columnName: "Editable",
      title: "Editable",
      key: "Editable",
      order: 999,
      subType: "text",
      datatype: 'calculated',
      hidden: true,
    };
    return [...base, Editable];
  }, [props.columns]);

  const { sitesResp } = useNav()
  const projectSite = findProjectParent(sitesResp, props.siteId);
  const [showPanel, setShowPanel] = useState<boolean>(false);
  const showPanelRef = useRef(false);
  showPanelRef.current = showPanel;



  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [formMode, setformMode] = useState<string>('');
  const [effectiveSiteId, setEffectiveSiteId] = useState<string>(props.siteId);
  const { getAccessToken } = useAuth();
  const { clientName, clientAPIURL } = useClient();
  const [packageId, setPackageId] = useState<string>(undefined);
  const [packageStatusItems, setPackageStatusItems] = useState(undefined);
  const formColumns = {
    columns: props.columns.sort((a, b) => a.order - b.order).map((column) => {
      //  if (column.hidden === true) {
      //    return null;
      //  }
      return {
        label: column.title,
        key: column.columnName,
        datatype: column.datatype,
        width: 100,
        subType: column.subType,
        options: column.choiceChoices,
        choiceType: column.choiceType,
        order: column.order,
        required: column.required,
        multiline: column.multiline,
        hidden: column.hidden
      }
    }).filter((column) => column !== null),
  };
  useEffect(() => {
    setSelectedRows([]);
  }, [props.siteId, props.logTitle]);
  useEffect(() => {
    if (props.logTitle === "Environmental Issues Observations" && props.QueryStringID) {
      const itemId = Number(props.QueryStringID);
      if (itemId > 0) {
        handleQueryStringItem(itemId);
      }
    }
  }, [props.QueryStringID, props.logTitle]);

  useEffect(() => {
    async function fetchData() {
      try {
        const logTitle = props.logTitle;
        let accessToken = await getAccessToken();
        let packageId = undefined;
        if (props.logTitle === "Package Status" || props.logTitle === "Contracts" || props.logTitle === "Permit And Licenses" || props.logTitle === "Permit Register") {
          packageId = props?.siteId && props.siteId;
        }
        else {
          const packageSite = findImmediateParent(sitesResp, props.siteId);
          if (packageSite && packageSite.id) {
            packageId = packageSite.id;
          }
        }

        // if (packageId) {
          setPackageId(packageId);
          const json = await getAllItems(logTitle, accessToken, clientAPIURL, props.siteId, projectSite.id ? projectSite.id : "", packageId ? packageId : undefined);
          const _packageStatusItems = packageId && await getPackageStatus(accessToken, clientAPIURL, packageId);
          setPackageStatusItems(_packageStatusItems);
          accessToken = null;
          const updatedData = json.items && json.items ? json.items : props.data
          setData(updatedData);
          !showPanelRef.current && setSelectedRows([]);
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    if (!showPanel && !props.isConsolidatedTable) {
      // if (props.logTitle === "Environmental Issues Observations"){fetchData();}
      sitesResp && fetchData()
    }
  }, [!showPanel, sitesResp]);


  const updateFormState = useCallback(() => {

    setShowPanel(prev => {
      const newValue = !prev;
      props.funcSetShowFilter && props.funcSetShowFilter(newValue);
      return newValue;
    });
  }, [props.funcSetShowFilter && props.funcSetShowFilter]);

  const updateFormMode = (val: string) => {

    console.log("Form mode set to:", val);
    if (val === 'New') setSelectedRows([]);
    setformMode(val);
    if (val === 'New') updateFormState();
  };

  function ItemCreated(item: Array<any>) {

    props && props.logTitle && props.logTitle === "Report Request" && props.updateData(item);
    setSelectedRows([]);
    updateFormState();
  }

  const handleRowPress = useCallback((row: any) => {
    const rowId: number = row.ID;
    setSelectedRows(prev =>
      prev.includes(rowId) ? prev.filter(ID => ID !== rowId) : [...prev, rowId]
    );
  }, []);


  function handleQueryStringItem(sRows: number) {
    const selectedItem = data.find(item => item.ID === sRows);
    if (!selectedItem) return;

    setSelectedRows([selectedItem]);
    setformMode("View");
    setShowPanel(true);
    props.funcSetShowFilter && props.funcSetShowFilter(true); // Explicitly setting, not relying on old state
  };

  function ViewPressAction(sRows: any) {
    let selectedItem: any[];
    if (props.isConsolidatedTable) {
      // sRows[0] is the processed row from ReactDataTable — use it for listId only
      const processedRow = sRows[0];
      const listId = processedRow?.listId;
      const parentSite = listId && findImmediateParent(sitesResp, listId);
      setEffectiveSiteId(parentSite?.id ?? props.siteId);
      // Look up the original unprocessed row in TableProvider.data so the form gets
      // raw field values (e.g. Attachments as JSON string, not a count)
      const originalRow = data.find(item =>
        item.ID === processedRow?.ID && item.packageName === processedRow?.packageName
      );
      selectedItem = originalRow ? [originalRow] : sRows;
    } else {
      selectedItem = data && data.filter(item => item.ID === sRows[0]);
      setEffectiveSiteId(props.siteId);
    }
    selectedItem && setSelectedRows(selectedItem);
    updateFormState();
  };
  function EditPressAction(sRows: any) {
    const selectedItem = data.filter(item => item.ID === sRows[0]);
    setSelectedRows(selectedItem);
    updateFormState();

  };
  function NewPressAction() {
    setSelectedRows([]);
    updateFormState();
  };
  function chartVisibility(val: boolean) {
    props.chartVisibility && props.chartVisibility(val)
    setShowPanel(false);
    props.funcSetShowFilter && props.funcSetShowFilter(true);
  }

  const formsMap: Record<string, React.FC<any>> = {
    "Environmental Issues Observations": WebObservationForm,
    "Waste Tracking Log": WasteTrackingForm,
    "Report Request": ReportRequestForm,
    "Package Status": ProjectStatusForm,
    "default": PaperForm,
  };

  const SelectedForm = formsMap[props.logTitle] || formsMap["default"];


  return (
    <View style={{ flex: 1 }}>
      {/* Always show table */}
      <ReactDataTable
        siteId={props.siteId}
        logTitle={props.logTitle}
        data={sortedData}
        columns={columns}
        updateFormState={updateFormState}
        updateFormMode={updateFormMode}
        handleRowPress={handleRowPress}
        ViewPressAction={ViewPressAction}
        EditPressAction={EditPressAction}
        NewPressAction={NewPressAction}
        isConsolidatedTable={props.isConsolidatedTable}
        setRefreshData={props.setRefreshData}
        selectedYear={props.selectedYear}
        isFormOpen={showPanel}
      />

      {/* Slide-in panel */}
      <RightPanel visible={showPanel} onClose={() => { setShowPanel(false); setSelectedRows([]); setformMode(''); setEffectiveSiteId(props.siteId); }}>
        <SelectedForm
          fields={formColumns.columns}
          formMode={formMode}
          selectedRow={selectedRows}
          closeForm={updateFormState}
          siteId={effectiveSiteId}
          logTitle={props.logTitle}
          updateFormState={updateFormState}
          ItemCreated={ItemCreated}
          Permissions={props.Permissions}
          chartVisibility={chartVisibility}
          packageId={packageId}
          packageStatusItems={packageStatusItems}

        />
      </RightPanel>

    </View>
  );
};

export default PaperTableDynamic;
